var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-container"},[(_vm.showLogo)?_c('logo',{attrs:{"collapse":_vm.isCollapse}}):_vm._e(),_c('sidebar-menu',{staticClass:"sidebar-menu"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }